import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Award, CheckCircle } from 'lucide-react';

const Certifications = () => {
  const certifications = [
    {
      title: 'AI Fundamentals',
      issuer: 'IBM',
      date: '2024',
    },
    {
      title: 'Customer Engagement',
      issuer: 'IBM',
      date: '2024',
    },
    {
      title: 'CSS Skill Certification',
      issuer: 'HackerRank',
      date: '2024',
    },
    {
      title: 'SQL Certification',
      issuer: 'SkillRack',
      date: '2024',
    },
    {
      title: 'CSS Certification',
      issuer: 'Udemy',
      date: '2024',
    },
    {
      title: 'JavaScript Certification',
      issuer: 'Udemy',
      date: '2024',
    },
    {
      title: 'Bootstrap Certification',
      issuer: 'Udemy',
      date: '2024',
    },
  ];

  return (
    <section id="certifications" className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            Certifications & <span className="text-teal-500">Achievements</span>
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {certifications.map((cert, index) => (
            <Card
              key={index}
              className="p-6 bg-white/70 dark:bg-slate-800/70 backdrop-blur-sm border-slate-200 dark:border-slate-700 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 group animate-in fade-in slide-in-from-bottom"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-lg bg-teal-500/10 text-teal-500 group-hover:bg-teal-500 group-hover:text-white transition-colors">
                  <Award className="h-6 w-6" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">
                    {cert.title}
                  </h3>
                  <p className="text-slate-600 dark:text-slate-300 text-sm mb-1">{cert.issuer}</p>
                  <p className="text-slate-500 dark:text-slate-400 text-xs">{cert.date}</p>
                </div>
                <CheckCircle className="h-5 w-5 text-green-500" />
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
